module.exports = __webpack_public_path__ + "fonts/iconfont.0956688.ttf";